@if (mainImage$ | async; as main) {
  <cx-media [container]="main"> </cx-media>
  }  @if (thumbs$ | async; as thumbs) {
  <ng-container class="product-image">
    @if (thumbs.length) {
      <cx-carousel
        class="thumbs"
        [items]="thumbs"
        itemWidth="120px"
        [hideIndicators]="false"
        [template]="thumb"
      ></cx-carousel>
    }
  </ng-container>
}

<ng-template #thumb let-item="item">
  <cx-media
    [container]="item.container"
    tabindex="0"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
    >
  </cx-media>
</ng-template>

<!-- <img [src]="selectedImage" alt="Product Image" class="product-image" />
<div class="thumbnail-container">
  <img *ngFor="let image of imageList; let i = index" [src]="image" [class.selected]="selectedIndex === i"
    (click)="selectImage(i)" class="thumbnail" />
  </div> -->